import HeaderNavigateButton from "@components/ui/HeaderNavigateButton"
import documentIcon from "@assets/images/icons/documentIcon.png"
import listIcon from "@assets/images/icons/listIcon.png"

import "./AvisosHeader.scss"

const AvisosHeader = () => {
  return (
    <div className="ef-avisos-header">
      <HeaderNavigateButton
        icon={documentIcon}
        label="Nuevo aviso"
        path="/avisos/nuevo"
        color="secondary"
      />
      {/* Desaparecemos el listado de borradores de avisos. MICRO-1311. */}
      {/* <HeaderNavigateButton
        icon={listIcon}
        label="Borradores de avisos"
        path="/borradores-avisos"
        color="primary"
        variant="outlined"
      /> */}
      <HeaderNavigateButton
        icon={listIcon}
        label="Listado de avisos"
        path="/avisos"
        color="primary"
        variant="outlined"
      />
    </div>
  )
}

export default AvisosHeader